import { useTheme } from "@mui/material";
import { PageHeader, PageHeaderProps } from "./PageHeader";
import Box from "@mui/material/Box";

type PageLayoutProps = PageHeaderProps;
export function PageLayout({ title, children }: React.PropsWithChildren<PageLayoutProps>) {
	const theme = useTheme();
	return (
		<Box width="100%" height="100%" display="flex" flexDirection="column">
			<Box
				flexGrow={0}
				paddingTop={theme.spacing(2)}
				paddingBottom={theme.spacing(4)}
				paddingX={theme.spacing(8)}
				bgcolor={theme.palette.background.default}
			>
				<PageHeader title={title} />
			</Box>
			<Box flex={`0 0 ${theme.spacing(12)}`} bgcolor={theme.palette.background.default} />
			<Box
				flexGrow={1}
				marginTop={`-${theme.spacing(12)}`}
				paddingBottom={theme.spacing(4)}
				paddingX={theme.spacing(8)}
			>
				{children}
			</Box>
		</Box>
	);
}
